<nb-card class="no-edge-card mb-0 detalle-centro-card">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-header class="border-bottom-0 detalle-header">
		<div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
			<div class="d-flex align-items-center gap-3">
				<nb-icon icon="home-outline" class="header-icon"></nb-icon>
				<div>
					<h4 class="m-0 header-title">{{centerName}}</h4>
					<small class="header-subtitle">Estudio Científico - Detalle del Centro</small>
				</div>
			</div>
			<div class="stats-container">
				<div class="stat-item">
					<span class="stat-value">{{grupos.length}}</span>
					<span class="stat-label">Grupos</span>
				</div>
				<div class="stat-item">
					<span class="stat-value">{{profesores.length}}</span>
					<span class="stat-label">Profesores</span>
				</div>
				<div class="stat-item">
					<span class="stat-value">{{mandos.length}}</span>
					<span class="stat-label">Mandos</span>
				</div>
			</div>
		</div>
	</nb-card-header>

	<div class="tabs-container">
		<div class="tab-buttons">
			<button class="tab-btn" [class.active]="activeTab === 'grupos'" (click)="setTab('grupos')">
				<nb-icon icon="people-outline"></nb-icon>
				Grupos
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'dashboard'" (click)="setTab('dashboard')">
				<nb-icon icon="bar-chart-outline"></nb-icon>
				Dashboard
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'profesores'" (click)="setTab('profesores')">
				<nb-icon icon="person-outline"></nb-icon>
				Profesores
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'mandos'" (click)="setTab('mandos')">
				<nb-icon icon="keypad-outline"></nb-icon>
				Mandos
			</button>
		</div>
	</div>

	<nb-card-body class="p-0">
		<!-- Tab: Grupos -->
		<div *ngIf="activeTab === 'grupos'">
			<div class="table-container" *ngIf="!loadingGrupos; else loadingTpl">
				<nb-form-field class="table-search-field" *ngIf="grupos.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchGrupos">
				</nb-form-field>
				<table class="detalle-table" *ngIf="grupos.length > 0; else emptyGruposTpl">
					<thead>
						<tr>
							<th class="sortable" (click)="sortGrupos('title')">Nombre del Grupo <span class="sort-icon">{{ getGruposSortIcon('title') }}</span></th>
							<th class="sortable" (click)="sortGrupos('nivel')">Nivel <span class="sort-icon">{{ getGruposSortIcon('nivel') }}</span></th>
							<th class="sortable" (click)="sortGrupos('letras')">Letras <span class="sort-icon">{{ getGruposSortIcon('letras') }}</span></th>
							<th class="sortable" (click)="sortGrupos('assignedStudents')">Estudiantes <span class="sort-icon">{{ getGruposSortIcon('assignedStudents') }}</span></th>
							<th class="sortable" (click)="sortGrupos('assignedProjects')">Proyectos Asignados <span class="sort-icon">{{ getGruposSortIcon('assignedProjects') }}</span></th>
							<th>Acciones</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let grupo of gruposFiltrados">
							<td class="font-weight-bold">{{grupo.title}}</td>
							<td>{{grupo.nivel || '—'}}</td>
							<td>{{grupo.letras || '—'}}</td>
							<td>{{grupo.assignedStudents ?? '—'}}</td>
							<td>{{grupo.assignedProjects ?? '—'}}</td>
							<td class="actions-cell">
								<button nbButton size="small" status="primary" ghost
									nbTooltip="Ver detalle del grupo" (click)="verDetalleGrupo(grupo)">
									<nb-icon icon="eye-outline"></nb-icon>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<ng-template #emptyGruposTpl>
					<div class="empty-state">
						<nb-icon icon="people-outline" class="empty-icon"></nb-icon>
						<p>Este centro no tiene grupos registrados</p>
					</div>
				</ng-template>
			</div>
		</div>

		<!-- Tab: Dashboard -->
		<div *ngIf="activeTab === 'dashboard'">
			<app-dashboard-estudio
				[level]="'center'"
				[idCenter]="idCenter">
			</app-dashboard-estudio>
		</div>

		<!-- Tab: Profesores -->
		<div *ngIf="activeTab === 'profesores'">
			<div class="table-container" *ngIf="!loadingProfesores; else loadingTpl">
				<nb-form-field class="table-search-field" *ngIf="profesores.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchProfesores">
				</nb-form-field>
				<table class="detalle-table" *ngIf="profesores.length > 0; else emptyProfesoresTpl">
					<thead>
						<tr>
							<th class="sortable" (click)="sortProfesores('name')">Nombre <span class="sort-icon">{{ getProfesoresSortIcon('name') }}</span></th>
							<th class="sortable" (click)="sortProfesores('surname')">Apellido <span class="sort-icon">{{ getProfesoresSortIcon('surname') }}</span></th>
							<th class="sortable" (click)="sortProfesores('email')">Email <span class="sort-icon">{{ getProfesoresSortIcon('email') }}</span></th>
							<th class="text-right">Acciones</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let profesor of profesoresFiltrados">
							<td class="font-weight-bold">
								<a class="teacher-link" *ngIf="profesor.idUser; else profNamePlain" (click)="verDashboardProfesor(profesor)">
									{{profesor.name || profesor.firstName || '—'}}
								</a>
								<ng-template #profNamePlain>{{profesor.name || profesor.firstName || '—'}}</ng-template>
							</td>
							<td>{{profesor.surname || profesor.surName || '—'}}</td>
							<td>{{profesor.email || profesor.mail || '—'}}</td>
							<td class="text-right">
								<button nbButton size="small" status="primary" ghost
										*ngIf="profesor.idUser"
										nbTooltip="Ver dashboard del profesor en el centro"
										(click)="verDashboardProfesor(profesor)">
									<nb-icon icon="bar-chart-outline"></nb-icon>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<ng-template #emptyProfesoresTpl>
					<div class="empty-state">
						<nb-icon icon="person-outline" class="empty-icon"></nb-icon>
						<p>No se encontraron profesores asociados a este centro</p>
					</div>
				</ng-template>
			</div>
		</div>

		<!-- Tab: Mandos -->
		<div *ngIf="activeTab === 'mandos'">
			<div class="table-container" *ngIf="!loadingMandos; else loadingTpl">
				<nb-form-field class="table-search-field" *ngIf="mandos.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchMandos">
				</nb-form-field>
				<table class="detalle-table" *ngIf="mandos.length > 0; else emptyMandosTpl">
					<thead>
						<tr>
							<th class="sortable" (click)="sortMandos('idMando')">ID Mando <span class="sort-icon">{{ getMandosSortIcon('idMando') }}</span></th>
							<th class="sortable" (click)="sortMandos('mac')">MAC <span class="sort-icon">{{ getMandosSortIcon('mac') }}</span></th>
							<th class="sortable" (click)="sortMandos('estado')">Estado <span class="sort-icon">{{ getMandosSortIcon('estado') }}</span></th>
							<th class="sortable" (click)="sortMandos('battery')">Batería <span class="sort-icon">{{ getMandosSortIcon('battery') }}</span></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let mando of mandosFiltrados">
							<td class="font-weight-bold">{{mando.idMando}}</td>
							<td>{{mando.mac || '—'}}</td>
							<td>
								<span class="estado-badge" [ngClass]="getEstadoClass(mando.estado)">
									{{getEstadoLabel(mando.estado)}}
								</span>
							</td>
							<td>{{mando.battery != null ? mando.battery + '%' : '—'}}</td>
						</tr>
					</tbody>
				</table>
				<ng-template #emptyMandosTpl>
					<div class="empty-state">
						<nb-icon icon="keypad-outline" class="empty-icon"></nb-icon>
						<p>No se encontraron mandos asociados a este centro</p>
					</div>
				</ng-template>
			</div>
		</div>

		<ng-template #loadingTpl>
			<div class="loading-state">
				<nb-spinner status="primary" size="large"></nb-spinner>
			</div>
		</ng-template>
	</nb-card-body>
</nb-card>
